import React, { useState } from "react";
import ReactDOM from "react-dom";

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";

import "firebase/compat/analytics";
import Login from "./Login";
import Homepage from "./Homepage";
import About from "./components/About";

import { useAuthState } from "react-firebase-hooks/auth";
import { useCollectionData } from "react-firebase-hooks/firestore";

firebase.initializeApp({
  apiKey: "AIzaSyDvCdzWJElMBdmVyVJHth5iohNPQkT_5BQ",
  authDomain: "engineering-college-finder-ark.firebaseapp.com",
  projectId: "engineering-college-finder-ark",
  storageBucket: "engineering-college-finder-ark.appspot.com",
  messagingSenderId: "579203198728",
  appId: "1:579203198728:web:a5072df132d8a2fb5e46bd",
  measurementId: "G-GV76NHFR7D",
});

const auth = firebase.auth();
firebase.analytics();

// Firebase initialization and configuration

function App() {
  const [user, setUser] = useState(null);

  // Check if the user is logged in
  firebase.auth().onAuthStateChanged((loggedInUser) => {
    if (loggedInUser) {
      setUser(loggedInUser);
    } else {
      setUser(null);
    }
  });
  return <div className="App">{user ? <Homepage /> : <Homepage />}</div>;
}

export default App;
